import { Navigate, useParams } from "react-router";
import AsciiImageViewer from "../components/AsciiImageViewer";
import styled from "styled-components";
import StreamingGrid from "../Layouts/StreamingGrid";
import artists from "../data/artists";

export default function Release() {
  // todo: lazy load component from github json storage
  const { id } = useParams();
  const releases = JSON.parse(localStorage.getItem("releases"))
  const isTouchScreen = 'ontouchstart' in window || navigator.msMaxTouchPoints;
  const loadedData = releases[releases.findIndex(i => i.path === id)];

  const Title = styled.div `
  font-family: sirquitry;
  font-size: 15pt;
  margin-bottom: 10pt;
  `

  const BodyText = styled.div `
  font-family: kingoe;
  font-size: 16pt;
  `

  const SideDetail = styled.div `
  margin-top: 5px;
  font-family: frensel;
  `

  return (
    loadedData ?
    (
        <div style={{ padding: "12px", lineHeight: 1.4, margin: "0" }}>
            <div style={{ float: "left", width: "38%", maxWidth: "400px", margin: "0px 14px 14px 0px" }}>   
                <AsciiImageViewer src={loadedData.media} cols={50} mode={isTouchScreen ? 1 : null} />
                <StreamingGrid links={loadedData.details.streaming}/>
                {loadedData.details['rd'] && <SideDetail>Released On: {loadedData.details.rd}</SideDetail>}
                {loadedData.details['artist'] && <SideDetail>
                    Art by {artists[loadedData.details.artist].name}
                </SideDetail>}
            </div>
            <Title>REL :? {loadedData.title || id}</Title>
            <BodyText>
                {loadedData.details['desc'] && loadedData.details.desc}
            </BodyText>
            <div style={{ clear: "both" }} />
        </div>
    ) : <Navigate to="/404" replace />
  );
}